/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Heart Stroke',
  definitions: {
    '24': {
      viewBox: '0 0 20 18',
      path: (
        <>
          <path
            id="Path (Stroke)"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.99999 3.37296L9.15814 2.5442C7.33757 0.751933 4.37816 0.751933 2.55758 2.5442C0.747473 4.32616 0.747473 7.20739 2.55758 8.98936L1.71573 9.84451C-0.571909 7.59244 -0.571909 3.94112 1.71573 1.68905C4.00337 -0.563017 7.71236 -0.563017 9.99999 1.68905C12.2876 -0.563017 15.9966 -0.563017 18.2843 1.68905C20.5719 3.94112 20.5719 7.59244 18.2843 9.84451L10 18L1.71573 9.84451L2.55758 8.98936L10 16.3161L17.4424 8.98936C19.2525 7.20739 19.2525 4.32616 17.4424 2.5442C15.6218 0.751933 12.6624 0.751933 10.8418 2.5442L9.99999 3.37296Z"
            fill="currentColor"
          />
        </>
      )
    },
    '32': {
      viewBox: '0 0 32 32',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 7.93598L15.1581 7.10722C12.575 4.56426 8.37924 4.56426 5.79612 7.10722C3.22346 9.63987 3.22346 13.7382 5.79612 16.2709L4.96818 17.1119L5.79612 16.2709L16 26.3161L26.2038 16.2709C28.7765 13.7382 28.7765 9.63987 26.2038 7.10722C23.6207 4.56426 19.4249 4.56426 16.8418 7.10722L16 7.93598ZM16 28L4.95426 17.126C1.90408 14.1233 1.90408 9.25482 4.95426 6.25207C8.00445 3.24931 12.9498 3.24931 16 6.25207C19.0501 3.24931 23.9955 3.24931 27.0457 6.25207C30.0958 9.25482 30.0958 14.1233 27.0457 17.126L16 28Z"
            fill="currentColor"
          />
        </>
      )
    }
  }
};

const icon = createSvgIcon(config);
export default icon;
